import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class FingerprintApi {
    private service: string = 'marketplace';
    private model: string = 'fingerPrint';

    constructor(public nestApiProvider: NestApiProvider) {}

    public getFeature(param: any): Observable<any> {
        const method: string = 'GET';
        const func: string = 'getFeature';
        const params: any = {};
        const urlParams: any = param;
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
        return this.nestApiProvider.request(method, url, params, urlParams, body);
    }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/fingerprint.api.ts